'use client';

import { useActionsRequired, type Action } from '@shared/hooks';
import { useRouter } from 'next/navigation';
import { useKycDialog } from '../../global-dialogs/components/KycDialog/context/KycDialogContext';
import { ActionsRequiredSection } from '../ActionsRequiredSection/ActionsRequiredSection';

function ActionsRequired() {
  const { data: actions } = useActionsRequired();
  const { openKycDialog } = useKycDialog();
  const router = useRouter();

  if (!actions?.length) {
    return null;
  }

  const handleAction = (action: Action) => {
    if (action.type === 'IDENTITY') {
      openKycDialog();
      return;
    }
    if (action.link) {
      router.push(action.link);
    }
  };

  return <ActionsRequiredSection namespace="my_account.actions_required" actions={actions} onAction={handleAction} />;
}

export { ActionsRequired };
